import React from "react";
import Button from "../Button";
import { SeeIngredientsProps } from "./type";
import { Info } from "react-feather";
import i18next from "i18next";

const SeeIngredientsCTA = ({ onClick }) => {
    return (
        <Button
            onClick={onClick}
            customStyle="see-ingredints-cta"
            size="XS"
            variant="secondary"
            label={i18next.t("complementary.ingredients")}
            icon={<Info />}
        />
    );
};

SeeIngredientsCTA.propTypes = SeeIngredientsProps;
export default SeeIngredientsCTA;
